<template>
<svg viewBox="0 0 48 48" fill="none" :class="[`${prefix}-icon`, `${prefix}-icon-reading-list-fill`]" width="1em" height="1em" v-bind="$attrs"><path :fill="useCurrentColor ? 'currentColor' : '#fff'" d="M0 0h48v48H0z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M38.875 4C40.049 4 41 4.818 41 5.818v36.364c0 1-.95 1.818-2.125 1.818H9.125C7.951 44 7 43.182 7 42.182V5.818C7 4.818 7.95 4 9.125 4h29.75z" :fill="useCurrentColor ? 'currentColor' : '#2B2F36'"/><path d="M15 23a1 1 0 011-1h11a1 1 0 011 1v1.5a1 1 0 01-1 1H16a1 1 0 01-1-1V23z" :fill="useCurrentColor ? 'currentColor' : '#fff'"/><rect x="15" y="16.5" width="18" height="3.5" rx="1" :fill="useCurrentColor ? 'currentColor' : '#fff'"/><rect x="15" y="27.5" width="18" height="3.5" rx="1" :fill="useCurrentColor ? 'currentColor' : '#fff'"/></svg>
</template>
<script>

export default {
  name: 'IconReadingListFill',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
